module.exports = __webpack_public_path__ + "img/relax.7b0106e0.svg";